const sanitize = (str: string) => {
  return str.replace(/(<([^>]+)>)/gi, '').replace(/\s\s+/g, ' ');
};

export default sanitize;
